import brandingDefaults from '../constants/default-data/branding';

const isDefaultSiteFooter = (siteFooter) =>
  siteFooter.url === brandingDefaults.siteFooter.url &&
  siteFooter.logo === brandingDefaults.siteFooter.logo;

export default isDefaultSiteFooter;
